import keyMirror from 'keymirror';

export default keyMirror({
  PRODUCT_GROUP_BTN_CREATE_PRODUCT_RENDERED: null,
  PRODUCT_GROUP_BTN_IMPORT_PRODUCT_RENDERED: null,
  PRODUCT_GROUP_RENDERED: null,
  PRODUCT_GROUP_LIST_RENDERED: null,
  PRODUCT_GROUP_VIEW_ALL: null,
  PRODUCT_GROUP_TITLE_RENDERED: null,
  PRODUCT_GROUP_NAME_RENDERED: null,
  PRODUCT_GROUP_CARD_NAME_RENDERED: null,
  PRODUCT_GROUP_PRICE_RENDERED: null,
  PRODUCT_GROUP_IMAGE_RENDERED: null,
  PRODUCT_GROUP_SALE_PRICE_RENDERED: null,
  PRODUCT_GROUP_EYEBROW_RENDERED: null,
  PRODUCT_GROUP_FOOTER_RENDERED: null,
  PRODUCT_GROUP_RIBBON_RENDERED: null,
  PRODUCT_GROUP_STAR_RATING_RENDERED: null,
  PG_NO_PRODUCTS_MESSAGE_RENDERED: null
});
